import {Placement} from '@popperjs/core';
import React, {FC, PropsWithChildren, ReactNode} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {FrontEvent} from '../../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {Link} from '../../../../../../libs/shared/ui/src/components/links/link';
import {TooltipCoordinator} from '../../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {openInBrowser} from '../../../../../../srcCommon/browser/openInBrowser';

/*
 * Props.
 */

interface AnalyticsTooltipsProps {
  isModalOpen: boolean;
  tooltipContent: string;
  placement?: Placement;
  conversationStageTypeLabel?: ReactNode;
  learnMoreUrl: string;
  isDisabled?: boolean;
}

/*
 * Styles.
 */

const StyledLink = styled(Link)`
  color: inherit;
  text-decoration: underline;
`;

const StyledDiv = styled.div`
  &::first-letter {
    text-transform: uppercase;
  }
`;

/*
 * Component.
 */

export const ActivityConversationStageUpdateTooltip: FC<PropsWithChildren<AnalyticsTooltipsProps>> = ({
  isModalOpen,
  tooltipContent,
  conversationStageTypeLabel,
  placement = 'top',
  learnMoreUrl,
  isDisabled = false,
  children,
}) => {
  const onLearnMoreClick = (event: FrontEvent) => {
    event.preventDefault();
    openInBrowser(learnMoreUrl);
  };

  const renderTooltipContent = () =>
    !isModalOpen && (
      <StyledDiv>
        <strong>{conversationStageTypeLabel}</strong> {tooltipContent}{' '}
        <StyledLink to={learnMoreUrl} onClick={onLearnMoreClick}>
          <Trans id="activity-stage-update-tooltip-learn-more">Learn more</Trans>
        </StyledLink>
      </StyledDiv>
    );

  return (
    <TooltipCoordinator
      persistent
      placement={placement}
      render={isDisabled ? false : () => renderTooltipContent()}
      isMultiline
    >
      {children}
    </TooltipCoordinator>
  );
};
